import { ID } from 'shared/types/id';

export enum TreeItemTypes {
  Root = 'root',
  LifeArea = 'lifeArea',
  Goal = 'goal',
  Priority = 'Priority',
  Date = 'date',
  DayPart = 'dayPart',
  Tag = 'tag',
  Task = 'task',
  Type = 'type',
  NewTask = 'newTask',
  Section = 'section',
}

export type TreeItem = {
  id: ID;
  name: string;
  type: TreeItemTypes;
  children?: ID[];
  isFolder?: boolean;
};

// Path-based identifier type to distinguish from generic strings
export type TreeItemID = string;

// Internal tree item with path-based ID and original source ID
export type InternalTreeItem = TreeItem & {
  sourceId: ID; // Original ID from TreeItem
  id: TreeItemID; // Path-based unique identifier
};
